import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import user, { UserState } from '@/store/modules/user';
import auth, { AuthState } from '@/store/modules/auth';
import accessories, { AccessoriesState } from '@/store/modules/accessories';

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  strictMode: true, // This **MUST** be set to true
  modules: ['user'],
});
export type Store = {
  user: UserState; // Location level store, container some data like Building, Floor, User data etc.
  auth: AuthState;
  accessories: AccessoriesState;
};

export default () =>
  new Vuex.Store<Store>({
    modules: {
      user,
      auth,
      accessories,
    },
    mutations: {
      RESTORE_MUTATION: vuexLocal.RESTORE_MUTATION, // this mutation **MUST** be named "RESTORE_MUTATION"
    },
    strict: process.env.NODE_ENV !== 'production',
    plugins: [vuexLocal.plugin],
  });
